import { render, staticRenderFns } from "./paymentInfo.vue?vue&type=template&id=1e533b2a&scoped=true&"
import script from "./paymentInfo.vue?vue&type=script&lang=ts&"
export * from "./paymentInfo.vue?vue&type=script&lang=ts&"
import style0 from "./paymentInfo.vue?vue&type=style&index=0&id=1e533b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e533b2a",
  null
  
)

export default component.exports